import styled from '@emotion/styled';

export const StyledPanel = styled.div`
	.ant-picker-time-panel-column {
		height: 100% !important;
	}
`;
